import React from 'react'

const AppContext = React.createContext({
        messages: {},
        labels: {},
        titles: {},
        routes: {},
        menus: {},
        userStatusManager: null,
        userPostTypeName: 'user',
        storage: function() {
        },
        template: null,
        style: {},
        lastUrl: '',
        account: {},
        setShouldLeaveWarning: function() {
        },
        getShouldLeaveWarning: function() {
        },
        device: null
    }
)

export default AppContext

